import { DropzoneProps, DropzoneHookProps } from '@procore/core-react/dist/_typedoc/Dropzone/Dropzone.types.json';
import * as React from 'react';
export default {
  DropzoneProps,
  DropzoneHookProps,
  React
};